import React from 'react';

import classNames from '../../utils/classNames';
import withInput from './withInput';

export const Radio = withInput(({ data, name, className, ...rest }) => {
  return (
    <div className={classNames('Form__Radio', className)} {...rest}>
      {data.map((value, i) => (
        <div className="Form__Radio__Option" key={i}>
          <input type="radio" name={name} value={value.value ? value.value : value} id={`${name}__${i}`} defaultChecked={value.checked} /> 
          <label htmlFor={`${name}__${i}`}>{value.label ? value.label : value}</label>
        </div>
      ))}
    </div>
  )
});
